// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var Warning_modal = require("../ui-utils/Warning_modal.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var MM_wrk_editor_json = require("../test/MM_wrk_editor_json.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var Warning = require("@mui/icons-material/Warning").default;

var defaultTestStmt = "|- ( ( a + b ) + ( c + d ) ) = 0";

function putSingleStatementToEditor(st, stmt) {
  var st$1 = MM_wrk_editor.completeDescrEditMode(st, "");
  var st$2 = MM_wrk_editor.completeVarsEditMode(st$1, "");
  var st$3 = MM_wrk_editor.completeDisjEditMode(st$2, "");
  var st$4 = MM_wrk_editor.checkAllStmts(st$3);
  var st$5 = MM_wrk_editor.deleteCheckedStmts(st$4);
  var match = MM_wrk_editor.addNewStmt(st$5, undefined, undefined);
  var st$6 = MM_wrk_editor.completeContEditMode(match[0], match[1], stmt);
  return MM_wrk_editor.verifyEditorState(st$6);
}

function prepareTestEditorState(preCtxData, testStmt) {
  return putSingleStatementToEditor(MM_wrk_editor_json.createInitialEditorState(preCtxData, undefined, 0), testStmt);
}

var warningText = "\n    Please be careful with what JavaScript code you use for transforms. \n    This code will be executed by your browser \"as is\" meaning no safety measures will be taken to protect your browser from hurmful code.\n    Before putting any code into this dialog please make sure you understand what that code does or make sure the code is not harmful.\n";

function MM_cmp_frag_transform_editor(props) {
  var onCancel = props.onCancel;
  var onSave = props.onSave;
  var isCustom = props.isCustom;
  var transformsText = props.transformsText;
  var title = props.title;
  var readOnly = props.readOnly;
  var preCtxData = props.preCtxData;
  var modalRef = props.modalRef;
  var match = Local_storage_utils.useStateFromLocalStorageStr("transform-editor-test-stmt", defaultTestStmt);
  var setTestStmt = match[1];
  var testStmt = match[0];
  var match$1 = React.useState(function () {
        return prepareTestEditorState(preCtxData, testStmt);
      });
  var setEditorState = match$1[1];
  var editorState = match$1[0];
  var match$2 = React.useState(function () {
        return true;
      });
  var setParenAc = match$2[1];
  var parenAc = match$2[0];
  var match$3 = React.useState(function () {
        return transformsText;
      });
  var setTransformsText = match$3[1];
  var transformsText$1 = match$3[0];
  var match$4 = Local_storage_utils.useStateFromLocalStorageBool("custom-transforms-js-warning-hide", false);
  var setHideWarning = match$4[1];
  var hideWarning = match$4[0];
  var actShowWarning = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Warning_modal.make, {
                                title: "Security warning",
                                warningText: warningText,
                                hideInit: hideWarning,
                                onHideChange: (function (b) {
                                    setHideWarning(function (param) {
                                          return b;
                                        });
                                  }),
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  React.useEffect((function () {
          if (!readOnly && !hideWarning) {
            actShowWarning();
          }
          
        }), []);
  var actUpdateEditorState = function (update) {
    setEditorState(function (st) {
          var st$1 = MM_wrk_editor.verifyEditorState(update(st));
          Belt_Option.forEach(Belt_Array.get(st$1.stmts, 0), (function (stmt) {
                  setTestStmt(function (param) {
                        return MM_wrk_editor.contToStr(stmt.cont);
                      });
                }));
          return st$1;
        });
  };
  var testStmtText = Belt_Option.map(Belt_Array.get(editorState.stmts, 0), (function (stmt) {
          return MM_wrk_editor.contToStr(stmt.cont);
        }));
  React.useEffect((function () {
          var exit = 0;
          if (!(testStmtText !== undefined && testStmtText !== "")) {
            exit = 1;
          }
          if (exit === 1) {
            actUpdateEditorState(function (__x) {
                  return putSingleStatementToEditor(__x, defaultTestStmt);
                });
          }
          
        }), [testStmtText]);
  var actTransformsTextUpdated = function (newTransformsText) {
    setTransformsText(function (param) {
          return newTransformsText;
        });
  };
  var rndTransformsText = function () {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, readOnly ? null : React.createElement("td", undefined, React.createElement(IconButton, {
                                  onClick: (function (param) {
                                      actShowWarning();
                                    }),
                                  color: "orange",
                                  title: "Security warning",
                                  children: Caml_option.some(React.createElement(Warning, {}))
                                })), React.createElement("td", {
                            style: {
                              paddingLeft: "5px"
                            }
                          }, React.createElement(TextField, {
                                value: transformsText$1,
                                label: title,
                                size: "small",
                                style: {
                                  width: "800px"
                                },
                                multiline: true,
                                maxRows: 10,
                                onChange: Expln_React_common.evt2str(actTransformsTextUpdated),
                                onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel),
                                disabled: readOnly,
                                autoFocus: true
                              })))));
  };
  var rndButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                style: {
                  padding: "4px"
                },
                children: Caml_option.some(null)
              }, readOnly ? null : React.createElement(Button, {
                      onClick: (function (param) {
                          Belt_Option.forEach(onSave, (function (onSave) {
                                  onSave(transformsText$1);
                                }));
                        }),
                      variant: "contained",
                      children: "Save"
                    }), React.createElement(Button, {
                    onClick: (function (param) {
                        onCancel();
                      }),
                    children: Caml_option.some(readOnly ? "Close" : "Cancel")
                  }));
  };
  var actToggleParenAc = function () {
    setParenAc(function (prev) {
          return !prev;
        });
  };
  var rndStmt = function (stmt) {
    var settings = editorState.preCtxData.settingsV.val;
    var tmp;
    if (isCustom) {
      var newrecord = Caml_obj.obj_dup(settings);
      newrecord.customTransforms = transformsText$1;
      tmp = newrecord;
    } else {
      tmp = settings;
    }
    return React.createElement(MM_cmp_user_stmt.make, {
                modalRef: modalRef,
                settingsVer: editorState.preCtxData.settingsV.ver,
                settings: tmp,
                preCtxVer: editorState.preCtxData.ctxV.ver,
                varsText: editorState.varsText,
                wrkCtx: editorState.wrkCtx,
                frms: editorState.preCtxData.frms,
                parenCnt: editorState.preCtxData.parenCnt,
                syntaxTypes: editorState.preCtxData.syntaxTypes,
                parensMap: editorState.preCtxData.parensMap,
                typeColors: editorState.preCtxData.typeColors,
                preCtxColors: editorState.preCtxData.symColors,
                wrkCtxColors: editorState.wrkCtxColors,
                editStmtsByLeftClick: settings.editStmtsByLeftClick,
                longClickEnabled: settings.longClickEnabled,
                longClickDelayMs: settings.longClickDelayMs,
                defaultStmtType: settings.defaultStmtType,
                showVisByDefault: settings.showVisByDefault,
                viewOptions: {
                  showCheckbox: false,
                  showLabel: false,
                  showType: false,
                  showJstf: false,
                  inlineMode: false,
                  smallBtns: false
                },
                readOnly: false,
                parenAc: parenAc,
                toggleParenAc: actToggleParenAc,
                stmt: stmt,
                onLabelEditRequested: (function () {
                    
                  }),
                onLabelEditDone: (function (param) {
                    
                  }),
                onLabelEditCancel: (function (param) {
                    
                  }),
                onTypEditRequested: (function () {
                    
                  }),
                onTypEditDone: (function (param, param$1) {
                    
                  }),
                onContEditRequested: (function () {
                    actUpdateEditorState(function (__x) {
                          return MM_wrk_editor.setContEditMode(__x, stmt.id);
                        });
                  }),
                onContEditDone: (function (newContText) {
                    actUpdateEditorState(function (__x) {
                          return MM_wrk_editor.completeContEditMode(__x, stmt.id, newContText);
                        });
                  }),
                onContEditCancel: (function (param) {
                    
                  }),
                onSyntaxTreeUpdatedWithoutContentChange: (function (newStmtCont) {
                    var stmtId = stmt.id;
                    actUpdateEditorState(function (__x) {
                          return MM_wrk_editor.setStmtCont(__x, stmtId, newStmtCont);
                        });
                  }),
                onJstfEditRequested: (function () {
                    
                  }),
                onJstfEditDone: (function (param) {
                    
                  }),
                onJstfEditCancel: (function (param) {
                    
                  }),
                checkboxDisabled: true,
                checkboxChecked: false,
                checkboxOnChange: (function (param, param$1) {
                    
                  }),
                onGenerateProof: (function () {
                    
                  }),
                onDebug: (function () {
                    
                  }),
                onOpenSubstitutionDialog: undefined,
                addStmtAbove: (function (param) {
                    
                  }),
                addStmtBelow: (function (param) {
                    
                  }),
                setShowTabs: (function (param) {
                    
                  }),
                openFrameExplorer: (function (param) {
                    
                  })
              });
  };
  var rndError = function (msgOpt, color) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: color
                  }
                }, msgOpt);
    } else {
      return React.createElement(React.Fragment, {});
    }
  };
  var rndErrors = function (stmt) {
    if (Belt_Option.isSome(stmt.stmtErr) || Belt_Option.isSome(stmt.syntaxErr) || Belt_Option.isSome(stmt.unifErr)) {
      return React.createElement(Expln_React_Column.make, {
                  style: {
                    marginLeft: "10px"
                  },
                  children: Caml_option.some(null)
                }, rndError(Belt_Option.map(stmt.stmtErr, (function (err) {
                            return err.msg;
                          })), "red"), rndError(Belt_Option.map(stmt.syntaxErr, (function (msg) {
                            if (msg === "") {
                              return "Syntax error.";
                            } else {
                              return "Syntax error - " + msg + ".";
                            }
                          })), "red"), rndError(stmt.unifErr, "darkgrey"));
    } else {
      return React.createElement(React.Fragment, {});
    }
  };
  var rndStmtAndErrors = function (stmt) {
    return JsxPPXReactSupportU.createElementVariadicWithKey(stmt.id, Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, [
                rndStmt(stmt),
                rndErrors(stmt)
              ]);
  };
  var rndStmts = function (editorState) {
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(editorState.stmts.map(rndStmtAndErrors))
              });
  };
  var rndEditorState = function () {
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                style: {
                  marginBottom: "10px"
                },
                children: Caml_option.some(rndStmts(editorState))
              });
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, "Test statement:", rndEditorState(), rndTransformsText(), rndButtons()))
            });
}

var make = MM_cmp_frag_transform_editor;

exports.defaultTestStmt = defaultTestStmt;
exports.putSingleStatementToEditor = putSingleStatementToEditor;
exports.prepareTestEditorState = prepareTestEditorState;
exports.warningText = warningText;
exports.make = make;
/* react Not a pure module */
